exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "input[type=radio]{accent-color:#000}.cont-radios{width:181px;display:flex;justify-content:space-evenly}", ""]);

// exports
